import { setParentSelectedChild } from '@store/parent/parentSelectedChildIdSlice';
import { useSelector, useDispatch } from 'react-redux'
import { Select } from "antd";
import { selectProfile } from '@store/profile.reducer'
import s from './ChoiceOfChildByParent.module.css';
import classNames from 'classnames';

const ChoiceOfChildByParent = ({className='', text=''}) => {
    const parentSelectedChildId = useSelector((state) => state.parentSelectedChildId);
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);

    return (
        <div className={classNames(s.selectChildrenWrapper, {[className]: !!className})}>
            <Select
                onChange={(childId) => dispatch(setParentSelectedChild(childId))}
                value={parentSelectedChildId}
                options={profile?.children?.map((child) => ({label: child.name, value: child?.id}))}
                className="antdSelectNewDesign"
                showSearch
                allowClear
                style={{minWidth: 250}}
                placeholder="Выберите ученика"
                filterOption={(input, option) => 
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) => (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())}
            />
        </div>
    )
}

export default ChoiceOfChildByParent;